var _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 22,
    viewBox: "0 0 49 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6234 11.6995C15.6454 10.0012 16.5626 8.39426 18.0177 7.50474C17.0997 6.20114 15.5623 5.37462 13.9627 5.32486C12.2566 5.14678 10.6026 6.34003 9.73316 6.34003C8.84693 6.34003 7.50835 5.34254 6.06692 5.37203C4.18808 5.43239 2.43654 6.49459 1.52244 8.12797C-0.4425 11.5108 1.02317 16.4825 2.90542 19.217C3.84715 20.556 4.94776 22.0517 6.38789 21.9986C7.79714 21.9405 8.32347 21.105 10.0246 21.105C11.7099 21.105 12.2037 21.9986 13.673 21.9649C15.1852 21.9405 16.138 20.62 17.0466 19.2683C17.7233 18.3142 18.2439 17.2598 18.5894 16.144C16.8122 15.3966 15.6255 13.6182 15.6234 11.6995Z",
    fill: "#470073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.848 3.52654C13.6726 2.54231 14.0788 1.27724 13.9804 0C12.7207 0.131561 11.5571 0.730217 10.7215 1.67669C9.90434 2.60144 9.47909 3.84424 9.55949 5.07267C10.8196 5.08557 12.0584 4.50314 12.848 3.52654Z",
    fill: "#470073"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M30.9467 1.30872C30.7221 1.54821 30.5894 1.9199 30.5894 2.40122V19.5982C30.5894 20.0803 30.7221 20.4513 30.9467 20.6908L31.0038 20.7467L40.5659 11.1133V10.9997V10.8862L31.0038 1.25195L30.9467 1.30872Z",
    fill: "#562C8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M43.753 14.3255L40.5662 11.1133V10.9997V10.8862L43.7538 7.6748L43.8256 7.71602L47.6021 9.8777C48.6803 10.4951 48.6803 11.5052 47.6021 12.1234L43.8256 14.285L43.753 14.3255Z",
    fill: "#562C8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8254 14.2843L40.5652 10.9998L30.9468 20.6908C31.3018 21.0702 31.8892 21.1169 32.5506 20.739L43.8254 14.2843Z",
    fill: "#470073"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8254 7.71527L32.5506 1.26133C31.8892 0.882643 31.3018 0.930076 30.9468 1.30954L40.566 11.0006L43.8254 7.71527Z",
    fill: "#470073"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 30.9468,
    y: 10.9998,
    width: 12.8787,
    height: 10.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogos);
export default __webpack_public_path__ + "static/media/logos.5dfe8a871799e6aab554b936fa55d9e5.svg";
export { ForwardRef as ReactComponent };